import { xor } from './utils/xor';
import { getSelectedTableView, TableQueryType, TableView } from 'owa-mail-list-store';
import { primaryMailboxSearchScope, SearchScopeKind, compareSearchScope } from 'owa-search-service';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import { getStore as getMailSearchStore } from 'owa-mail-search';
import getStaticSearchScope from 'owa-mail-search-next-lazy/lib/selectors/getStaticSearchScope';
import { isFeatureEnabled } from 'owa-feature-flags';

export const staticFolderSearchScopeRestriction = (
    staticFolders: string[],
    shouldHide?: boolean
) => () => {
    const tableView: TableView = getSelectedTableView();

    if (tableView.tableQuery.type !== TableQueryType.Search) {
        return true;
    }

    const staticSearchScope = isFeatureEnabled('sea-lazy2')
        ? getStaticSearchScope()
        : getMailSearchStore().staticSearchScope;

    const isStaticFolderInRestrictionList =
        staticFolders
            .map(distinguishedFolderId =>
                primaryMailboxSearchScope({
                    folderId: folderNameToId(distinguishedFolderId),
                    kind: SearchScopeKind.PrimaryMailbox,
                })
            )
            .filter(searchScope => compareSearchScope(searchScope, staticSearchScope)).length > 0;

    return xor(shouldHide, isStaticFolderInRestrictionList);
};
